import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import api from '../api/axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function EditarPerfil() {
  const [form, setForm] = useState({
    nombre: '',
    apellidos: '',
    telefono: '',
    email: '',
    contrasena: ''
  });

  const [datosOriginales, setDatosOriginales] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const datos = {
          nombre: decoded.nombre || '',
          apellidos: decoded.apellidos || '',
          telefono: decoded.telefono || '',
          email: decoded.email || ''
        };
        setForm(prev => ({ ...prev, ...datos }));
        setDatosOriginales(datos);
      } catch (err) {
        console.error('Error al decodificar token:', err);
      }
    }
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = value => {
    setForm({ ...form, telefono: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const { nombre, apellidos, telefono, email, contrasena } = form;
    if (!nombre.trim() || !apellidos.trim() || !telefono.trim() || !email.trim()) {
      return toast.warning('Todos los campos excepto la contraseña son obligatorios.');
    }

    const cambiosHechos = Object.keys(datosOriginales).some(
      key => form[key] !== datosOriginales[key]
    ) || contrasena;

    if (!cambiosHechos) {
      return toast.warning('No has realizado ningún cambio.');
    }

    try {
      const token = localStorage.getItem('token');
      const res = await api.put('/auth/perfil', form, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.token) {
        localStorage.setItem('token', res.data.token);
        toast.success('Perfil actualizado correctamente 🎉');
        setDatosOriginales({
          nombre,
          apellidos,
          telefono,
          email
        });
        setForm({ ...form, contrasena: '' }); // limpiar contraseña
      }
    } catch (err) {
      console.error('❌ Error al actualizar perfil:', err);
      toast.error('Hubo un error al actualizar el perfil.');
    }
  };

  return (
    <main className="editar-perfil site-width">
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar={false} />

      <div className="texto-dashboard">
        <h1>Editar perfil</h1>
        <p>Actualiza tus datos personales.</p>
      </div>

      <form onSubmit={handleSubmit} className='form-datos-personales'>
        <div className="label-form">
          <label htmlFor="nombre">Nombre:</label>
          <input type="text" name="nombre" value={form.nombre} onChange={handleChange} />
        </div>

        <div className="label-form">
          <label htmlFor="apellidos">Apellidos:</label>
          <input type="text" name="apellidos" value={form.apellidos} onChange={handleChange} />
        </div>

        <div className="label-form">
          <label htmlFor="telefono">Teléfono:</label>
          <PhoneInput
            country={'es'}
            value={form.telefono}
            onChange={handlePhoneChange}
            inputStyle={{ width: '100%' }}
          />
        </div>

        <div className="label-form">
          <label htmlFor="email">Email:</label>
          <input type="email" name="email" value={form.email} onChange={handleChange} />
        </div>

        <div className="label-form">
          <label htmlFor="contrasena">Nueva contraseña:</label>
          <input type="password" name="contrasena" value={form.contrasena} onChange={handleChange} />
        </div>

        <p className="warning-msg">Los datos vacíos no se actualizarán. Asegúrate de que los cambios sean correctos.</p>
        <button className='boton-editar-perfil' type="submit">Guardar cambios</button>
      </form>
    </main>
  );
}
